export default __webpack_public_path__ + "media/images/bars-c0703e81e07159e162d8ef2f1b4a718e.svg";